import React, { useCallback } from "/vendor/react";
import gql from "/vendor/graphql-tag";import {
  useApolloClient
} from "/lib/component/util";


const openModel = gql`
  mutation OpenSwitcher {
    toggleModal(modal: CREATE_HARDWARE_MODAL) @client
  }
`;

const HardwareCatAction = () => {
	const client = useApolloClient();
	const handleClick = useCallback(() => {

    	client.mutate({ mutation: openModel });
  }, [client]);

	const handleKeyDown = (event: any) => {
		if (event.key === 'Enter') {
			handleClick();
		}
	}

	return (
			<button style={{
				right: 15,
				left: "auto",
				float: "right",
				backgroundColor: "grey",
				color: "white",
				padding: "10px 20px",
				borderRadius: "5px",
				cursor: "pointer"
				}}
				onClick={handleClick}
				onKeyDown={handleKeyDown}
			>
				<span>H-Ware Catalog</span>
			</button>
	);
}

export default HardwareCatAction;
